import { Component, Input } from '@angular/core';
import {
  DEFAULT_APPLICATION_PHONE_NUMBER,
  ROCKET_MORTGAGE_CLOSING_TEAM_NUMBER,
} from 'src/app/features/shared/constants';

@Component({
    selector: 'app-support-phone-number-button',
    templateUrl: './support-phone-number-button.component.html',
    styleUrls: ['../../nav-bar.component.scss'],
    standalone: false
})
export class SupportPhoneNumberButtonComponent {
  @Input() showPhoneNumber = true;
  techSupportNumber = DEFAULT_APPLICATION_PHONE_NUMBER;
  documentAndLoanNumber = ROCKET_MORTGAGE_CLOSING_TEAM_NUMBER;

  /** Builds a tel: href from a display-formatted phone number. */
  telHref(phoneNumber: string): string {
    return 'tel:' + phoneNumber.replace(/[^\d+]/g, '');
  }
}
